import { ChangeEvent, FormEvent, useState } from "react";

export default function useInput(
  defaultValue: string
): [
  string,
  { value: string; onChange: React.ChangeEventHandler<HTMLInputElement> }
] {
  const [value, setValue] = useState(defaultValue);

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(e.target.value);
  };

  const props = {
    value,
    onChange,
  };

  return [value, props];
}
